import { z } from 'zod'

// the single shape every error response from the API takes. `message` is always
// present and always safe to show a user; `errorId` appears only when the backend
// could not classify the failure, and is the correlation key to the log line that
// carries the real cause (stack, gRPC code, upstream detail). clients should render
// `message`, and surface `errorId` verbatim so it can be pasted into a bug report.
export const apiErrorResponseSchema = z.object({
  statusCode: z.number().int(),
  message: z.string(),
  // Nest's own error bodies carry this (e.g. "Not Found"); kept optional so the
  // shape stays a superset of what the framework already emits.
  error: z.string().optional(),
  // present only on unclassified failures — a curated error never needs one
  errorId: z.string().optional(),
})

export type ApiErrorResponseDto = z.infer<typeof apiErrorResponseSchema>
